import { NodeProps, Node, Handle, Position } from "@xyflow/react";
import { WorkflowDiagramReactFlowProps } from "../WorkflowDiagramReactFlow";
import { workflowDiagramStyles } from "../workflowDiagramStyles";

import { NodeIcon } from "./NodeIcon";
import { nodeStyles } from "./nodeStyles";

export interface StepNodeProps extends NodeProps<
  Node<WorkflowDiagramReactFlowProps["graphNodes"][number]["data"]>
> {
  backgroundColor?: string;
  header?: React.ReactNode;
}

export const StepNode = ({
  data,
  sourcePosition,
  targetPosition,
  backgroundColor,
  header = <NodeIcon type="indexMapping" label="Input" />,
}: StepNodeProps) => (
  <div
    style={{
      ...nodeStyles.base,
      ...workflowDiagramStyles.shapes.step,
      ...(backgroundColor !== undefined
        ? { backgroundColor: backgroundColor }
        : {}),
    }}
    title={data.label}
  >
    {header}
    <div style={nodeStyles.name}>{data.label}</div>
    {data.subLabel !== undefined && (
      <div style={nodeStyles.subLabel}>{data.subLabel}</div>
    )}

    <Handle type="target" position={targetPosition ?? Position.Top} />
    <Handle type="source" position={sourcePosition ?? Position.Bottom} />
  </div>
);
